'use client';

import React, { useEffect, useRef } from 'react';
import Cart from 'components/commercetools-ui/organisms/cart';
import { CartProps } from 'components/commercetools-ui/organisms/cart/types';
import { TasticProps } from '../types';
import { useAccount } from 'frontastic/hooks';
import useLocale from 'helpers/hooks/useLocale';
import { DataLayerOnLoad } from 'helpers/dataLayerHelpers';

const CartTastic = ({ data, categories }: TasticProps<CartProps>) => {
  const { getCountry, getCurrency } = useLocale();
  const { account } = useAccount();
  const hasInitialized = useRef(false);

  useEffect(() => {
    const localeData = {
      country: getCountry(),
      currency: getCurrency(),
    };
    const currentUrl = document.location.origin;

    const dataLayer = new DataLayerOnLoad(currentUrl, 'cart', localeData, account);
    dataLayer.setDataLayerOnLoad();
  }, []);

  return <Cart {...data} categories={categories} />;
};

export default CartTastic;
